import React from "react";
import PropTypes from "prop-types";

/**
 * 顶部条：phase 切换器（标题和保存按钮都由调用方在外部渲染）。
 * phases 列表完全由调用方传入，不在内部 hardcode——可以传 1 个或多个。
 */
function Header({ activePhase, onPhaseChange, phases }) {
  return (
    <header className="tfe-header">
      <div className="tfe-phase-switcher">
        {phases.map((p) => (
          <button
            key={p.value}
            type="button"
            className={`tfe-phase-btn ${activePhase === p.value ? "active" : ""}`}
            onClick={() => onPhaseChange(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>
    </header>
  );
}

Header.propTypes = {
  activePhase: PropTypes.string.isRequired,
  onPhaseChange: PropTypes.func.isRequired,
  /** 顶部 phase 切换器要显示的列表：[{value, label}, ...] */
  phases: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Header;
